import { actionTypes} from '../actions/cryptoCurrencies'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes)
